import React from 'react';
import { ArrowLeft, Menu } from 'lucide-react';
interface HeaderProps {
  currentScreen: string;
  returnToDashboard: () => void;
}
export const Header: React.FC<HeaderProps> = ({
  currentScreen,
  returnToDashboard
}) => {
  const getTitle = () => {
    switch (currentScreen) {
      case 'dashboard':
        return 'BLAZE Ops';
      case 'runbook':
        return 'End-of-Day Closing';
      case 'review':
        return 'Manager Review';
      case 'report':
        return 'Closing Summary';
      default:
        return 'BLAZE Ops';
    }
  };
  return <header className="sticky top-0 z-10 bg-white border-b border-gray-200" data-id="element-95">
      <div className="max-w-md mx-auto px-4 h-16 flex items-center justify-between" data-id="element-96">
        <div className="flex items-center space-x-3" data-id="element-97">
          {currentScreen !== 'dashboard' && <button onClick={returnToDashboard} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100" data-id="element-98">
              <ArrowLeft className="w-5 h-5 text-gray-700" data-id="element-99" />
            </button>}
          <h1 className="text-xl font-bold text-gray-900" data-id="element-100">{getTitle()}</h1>
        </div>
        <button className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100" data-id="element-101">
          <Menu className="w-5 h-5 text-gray-700" data-id="element-102" />
        </button>
      </div>
    </header>;
};